export default __webpack_public_path__ + "static/media/47.59229998.png";